import React, { Component } from "react";

export default class WorkspaceTableChart extends Component {

    constructor(props) {

        super(props);

        window.workspaceTableChart = this;

        this.state = {
            resultsPerPage: 'All',//this.props.identity.height > 1 ? 15 : 10,
            pageNumber: 0,
            searchText: "",
            columnWidths: [],
            resultsPerPageMenuOpen: false,
            showGrandTotals: false,
            scrollPosition: 0
        };
        for (var i = 0; i < this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length; i++) {
            this.state.columnWidths.push(0);
        }

        this.renderedRowCnt = 75;

        this.grandTotal = {};

        this.idWidth = this.props.identity.width;

        this.handleSearchInput = this.handleSearchInput.bind(this);
        this.beginDrag = this.beginDrag.bind(this);
        this.doDrag = this.doDrag.bind(this);
        this.endDrag = this.endDrag.bind(this);
        this.searchData = this.searchData.bind(this);

        this.changePage = this.changePage.bind(this);
        this.toggleRowSettingOptions = this.toggleRowSettingOptions.bind(this);
        this.setResultsPerPage = this.setResultsPerPage.bind(this);
        this.getType = this.getType.bind(this);

        this.generateOptionsBar = this.generateOptionsBar.bind(this);
        this.generateHeaders = this.generateHeaders.bind(this);
        this.generateDataRows = this.generateDataRows.bind(this);
        this.generateDataRowsInfiniteScrollWay = this.generateDataRowsInfiniteScrollWay.bind(this);
        this.generateGrandTotalRow = this.generateGrandTotalRow.bind(this);
        this.generateTableFooter = this.generateTableFooter.bind(this);

        this.handleScrollEvent = this.handleScrollEvent.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        let columnWidths = this.state.columnWidths;
        for (var i = 0; i < columnWidths.length; i++) {
            columnWidths[i] = 0;
        }
        this.setState({ columnWidths: columnWidths });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.idWidth != this.props.identity.width) {
            this.idWidth = this.props.identity.width;
            let columnWidths = this.state.columnWidths;
            for (var i = 0; i < columnWidths.length; i++) {
                columnWidths[i] = 0;
            }
            this.setState({ columnWidths: columnWidths });
        }
    }

    handleSearchInput(e) {
        let text = e.target.value;

        this.setState({ searchText: text, pageNumber: 0 });
    }

    beginDrag(index, e) {
        e = e || window.event
        e.preventDefault();

        this.rem = parseFloat(getComputedStyle(document.documentElement).fontSize)

        this.dragX1 = 0;
        this.dragX2 = e.clientX;

        this.fullWidth = document.getElementById(`workspace-table-chart-${this.props.identity.id}`).offsetWidth;
        this.baseWidth = this.fullWidth / this.state.columnWidths.length;

        document.onmousemove = this.doDrag.bind(null, index);
        document.onmouseup = this.endDrag;
    }

    doDrag(index, e) {
        e = e || window.event
        e.preventDefault()

        this.dragX1 = this.dragX2 - e.clientX;
        this.dragX2 = e.clientX;

        let columnWidths = this.state.columnWidths;

        columnWidths[index] -= this.dragX1;
        columnWidths[index + 1] += this.dragX1;

        let tooSmall = columnWidths.reduce((r, e) => {
            if (this.baseWidth + e < 30) {
                r = true;
            }
            return r;
        }, false)

        if (tooSmall) {
            columnWidths[index] += this.dragX1;
            columnWidths[index + 1] -= this.dragX1;
        } else {
            this.setState({ columnWidths: columnWidths });
        }
    }

    endDrag(e) {
        document.onmouseup = null;
        document.onmousemove = null;
    }

    searchData() {

        if (this.state.searchText.trim().length === 0) {
            return this.props.data;
        }

        let tmpData = [];
        let data = this.props.data;
        let searchSplit = this.state.searchText.toUpperCase().split(' ');

        data.forEach(dat => {
            let found = false;
            let el;
            if(dat.info.storeId === undefined) {
                el = {
                    ...dat.info
                }
            } else {
                el = {
                    ...dat.info,
                    storeId: toFriendlyName(this.props.identity.dataSet, 'storeId', dat.info.storeId)
                }
            }
            let searchables = Object.values(el).reduce((r, e) => {
                if(e !== undefined) {
                    r.push(e.toUpperCase());
                } 
                return r;
            }, []);
            for (var i = 0; i < searchables.length; i++) {
                for (var j = 0; j < searchSplit.length; j++) {
                    if (searchSplit[j] != "" && searchables[i].includes(searchSplit[j])) {
                        found = true;
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
            if (found) {
                tmpData.push(dat);
            }
        })

        return tmpData;
    }

    changePage(inc) {
        let pageNumber = this.state.pageNumber;

        pageNumber += inc;
        if (pageNumber < 0) {
            pageNumber = 0;
        } else {
            let maxPage = Math.ceil(this.searchData().length / this.state.resultsPerPage) - 1;
            if (pageNumber > maxPage) {
                pageNumber = maxPage;
            }
        }

        this.setState({ pageNumber: pageNumber });
    }

    toggleRowSettingOptions(forceBool) {

        let tmpBool = typeof forceBool === "boolean" ? forceBool : !this.state.resultsPerPageMenuOpen;

        this.setState({ resultsPerPageMenuOpen: tmpBool });
    }

    setResultsPerPage(resultsPerPage) {
        this.setState({ resultsPerPage: resultsPerPage, resultsPerPageMenuOpen: false })
    }

    generateOptionsBar() {

        return (
            <div className={"options-bar-outer"}>
                {/* <div className={"material-icons other-button"}>{"view_column"}</div> */}
                <div className={"search-bar-container" + (this.state.searchText.trim().length === 0 ? "" : " locked")}>
                    <div className={"search-bar-inner"}>
                        <input className={"search-input"} type={"text"} value={this.state.searchText} onChange={this.handleSearchInput} />
                        <div className={"material-icons search-icon"}>{"search"}</div>
                    </div>
                </div>
            </div>
        )
    }

    generateHeaders() {

        let tableHeaders = [];
        let tableSortBy = this.props.tableSortBy;
        let columnCount = this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length;

        let colCounter = 0;

        this.props.identity.supportFields.forEach(field => {
            field = toCammelCase(field);
            tableHeaders.push((
                <div
                    className={"header-cell info"}
                    style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter]}px)` }}
                >
                    <div
                        className={`material-icons sort-icon ${field === tableSortBy.columnName ? "" : " hidden"} ${tableSortBy.isDesc ? " desc" : ""}`}
                        onClick={this.props.setTableSortBy.bind(null, field)}
                    >{"arrow_upward"}</div>
                    <div className={"header-cell-text"} onClick={this.props.setTableSortBy.bind(null, field)}>{generateFriendlyName(field, false)}</div>
                    <div className={"dragger"} onMouseDown={this.beginDrag.bind(null, colCounter++)}>
                        <div className={"dragger-inner"}></div>
                    </div>
                </div>
            ))
        })
        
        this.props.identity.selectedMetrics.forEach((meta, index) => {
            if(meta.metric.startsWith('SalesByDay')){
                let field = toCammelCase(meta.metric);
                tableHeaders.push((
                    <div
                        className={"header-cell kpi"}
                        style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter]}px)` }}
                    >
                        <div
                            className={`material-icons sort-icon ${meta.metric === tableSortBy.columnName ? "" : " hidden"} ${tableSortBy.isDesc ? " desc" : ""}`}
                            onClick={this.props.setTableSortBy.bind(null, meta.metric)}
                        >{"arrow_upward"}</div>
                        <div className={"header-cell-text"} onClick={this.props.setTableSortBy.bind(null, field)}>{generateFriendlyName(field, false)}</div>
                        <div className={"dragger"} onMouseDown={this.beginDrag.bind(null, colCounter++)}>
                            <div className={"dragger-inner"}></div>
                        </div>
                    </div>
                ))
            }
            else{
                if(meta.metric === 'locationAvgMonthlyClientVisits') {
                    console.log('aaa');
                }
                tableHeaders.push((
                    <div
                        className={"header-cell kpi"}
                        style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter]}px)` }}
                    >
                        <div
                            className={`material-icons sort-icon ${meta.metric === tableSortBy.columnName ? "" : " hidden"} ${tableSortBy.isDesc ? " desc" : ""}`}
                            onClick={this.props.setTableSortBy.bind(null, meta.metric)}
                        >{"arrow_upward"}</div>
                        <div className={"header-cell-text"} onClick={this.props.setTableSortBy.bind(null, meta.metric)}>
                            { meta.isYOY ? (generateFriendlyName(meta.metric, true) + " YOY") : generateFriendlyName(meta.metric, true)}</div>
                        {index >= this.props.identity.selectedMetrics.length - 1 ? null :
                            (<div className={"dragger"} onMouseDown={this.beginDrag.bind(null, colCounter++)}>
                                <div className={"dragger-inner"}></div>
                            </div>)}
                    </div>
                ))
            }
        })

        return tableHeaders;

    }

    generateDataRows(finalData) {

        let identity = this.props.identity;

        let dataRows = [];

        let pageNumber = this.state.pageNumber;
        let resultsPerPage = this.state.resultsPerPage;
        let indexStart = pageNumber * resultsPerPage;

        let columnCount = this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length;

        this.state.columnWidths.forEach(col => {
            if (col === undefined || col === NaN) {
                col = 0;
            }
        });

        let dataPieces = [];
        let colCounter = 0;
        for (var i = indexStart; i < indexStart + resultsPerPage; i++) {
            let dat = finalData[i];
            if (!dat) {
                break;
            }

            colCounter = 0;

            dataPieces = [];
            this.props.identity.supportFields.forEach(field => {
                field = field.substring(0, 1).toLowerCase() + field.substring(1);

                let supportFieldFriendlyName = "All";

                if (this.props.identity.isGroupable) {
                    this.props.identity.groupables.forEach(groupable => {
                        supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                    });
                } else {
                    supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                }

                dataPieces.push((
                    <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                        {supportFieldFriendlyName}
                    </div>
                ));
            })

            this.props.identity.selectedMetrics.forEach(meta => {
                let isNegative = false;
                if(this.props.metricDefs != undefined && meta != undefined) {
                    if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)] !== undefined) {
                        isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)].isNegative.toLowerCase());
                    }
                }  
                if(meta.isYOY) {
                    if(dat.kpi[meta.metric] !== undefined) {
                        let pctYoY = Math.abs((dat.kpi[meta.metric].lyValue - dat.kpi[meta.metric].cyValue) / dat.kpi[meta.metric].lyValue);
                        if(isNaN(pctYoY) || !isFinite(pctYoY) || pctYoY === null) {
                            pctYoY = 0;
                        }
                        // let increaseDecrease = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue ? "+" : "-";
     
                         let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;
     
                         dataPieces.push((
                             <div
                                 className={"body-cell kpi"}
                                 style={{
                                     width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                     color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                 }}>
                                 {pctYoY !== Infinity
                                 ? (100 * pctYoY).toFixed(2) + "% "
                                 : ""}
                             </div>
                         ))
                    }
                } else {
                    if(this.props.metaData[meta.metric] !== undefined && dat.kpi[meta.metric] !== undefined) {
                        let formatId = this.getType(dat.kpi[meta.metric].kpiIdentifier, this.props.identity.dataSet);
                        let type = formatId !== undefined ? formatId : this.props.metaData[meta.metric].type;
                        let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
                        let suffix = type === 'PCT' ? '%' : '';
                        let text = dat.kpi[meta.metric].cyValue;
                        text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));

                        let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                        dataPieces.push((
                            <div
                                className={"body-cell kpi"}
                                style={{
                                    width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                    color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                }}>
                                {prefix + text + suffix + " "}
                                <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad") + (this.props.isAABIDash ? " dispNone" : "")}>{"call_made"}</span>
                            </div>
                        ))
                    }  
                }    
            })

            dataRows.push((
                <div className={"table-row"}>{dataPieces}</div>
            ));
        }

        return dataRows;
    }

    getType(kpiIdentifier, dataset) {
		let type;
		if(dataset !== undefined) {
			if(this.props.metricDefs[dataset][window.toCammelCase(kpiIdentifier)] !== undefined) {
				type = this.props.metricDefs[dataset][window.toCammelCase(kpiIdentifier)].formatId;
			}
		}
		return type;
	}

    generateDataRowsInfiniteScrollWay(finalData) {

        let threshHoldRows = [];

        let identity = this.props.identity;

        let dataRows = [];

        let pageNumber = this.state.pageNumber;
        let resultsPerPage = this.state.resultsPerPage;


        let columnCount = this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length;

        this.state.columnWidths.forEach(col => {
            if (col === undefined || col === NaN) {
                col = 0;
            }
        });


        ///////////////////////////////////////////////--THE THRESHOLD ROWS...SHOULD THEY EXIST...for the first 10 rows
        let dataPieces = [];
        let colCounter = 0;
        if (this.state.scrollPosition > 1 && this.state.scrollPosition < 10) {
            for (var i = (this.state.scrollPosition - this.state.scrollPosition) + 0; i < this.state.scrollPosition + 0; i++) {
                //threshHoldRows.push(this.state.rows[t]);

                let dat = finalData[i];
                if (!dat) {
                    break;
                }

                colCounter = 0;

                dataPieces = [];
                this.props.identity.supportFields.forEach(field => {
                    field = field.substring(0, 1).toLowerCase() + field.substring(1);

                    let supportFieldFriendlyName = "All";

                    if (this.props.identity.isGroupable) {
                        this.props.identity.groupables.forEach(groupable => {
                            supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                        });
                    } else {
                        supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                    }

                    dataPieces.push((
                        <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                            {supportFieldFriendlyName}
                        </div>
                    ));
                })

                this.props.identity.selectedMetrics.forEach(meta => {
                    let isNegative = false;
                    if(this.props.metricDefs != undefined && meta != undefined) {
                        if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)] !== undefined) {
                            isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)].isNegative.toLowerCase());
                        }
                    } 
                    if(meta.isYOY) {
                        if(dat.kpi[meta.metric] !== undefined) {
                            let pctYoY = Math.abs((dat.kpi[meta.metric].lyValue - dat.kpi[meta.metric].cyValue) / dat.kpi[meta.metric].lyValue);
                        //let increaseDecrease = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue ? "+" : "-";

                            let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                            dataPieces.push((
                                <div
                                    className={"body-cell kpi"}
                                    style={{
                                        width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                        color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                    }}>
                                    {pctYoY !== Infinity
                                    ? (100 * pctYoY).toFixed(2) + "% "
                                    : ""}
                                </div>
                            ))
                        }
                    } else {
                        if(this.props.metaData[meta.metric] !== undefined && dat.kpi[meta.metric] !== undefined) {
                            let formatId = this.getType(dat.kpi[meta.metric].kpiIdentifier, this.props.identity.dataSet);
                            let type = formatId !== undefined ? formatId : this.props.metaData[meta.metric].type;
                            let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
                            let suffix = type === 'PCT' ? '%' : '';
                            let text = dat.kpi[meta.metric].cyValue;
                            text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));

                            let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                            dataPieces.push((
                                <div
                                    className={"body-cell kpi"}
                                    style={{
                                        width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                        color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                    }}>
                                    {prefix + text + suffix + " "}
                                    <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad") + (this.props.isAABIDash ? " dispNone": "")}>{"call_made"}</span>
                                </div>
                            ))
                        }                       
                    }
                })

                threshHoldRows.push((
                    <div key={i} className={"table-row"}>{dataPieces}</div>
                ));
            }
        }


        ///////////////////////////////////////////////--THE THRESHOLD ROWS...SHOULD THEY EXIST...for rows after the first 10 rows
        dataPieces = [];
        colCounter = 0;
        if (this.state.scrollPosition >= 10) {
            for (var i = (this.state.scrollPosition - 10) + 0; i < this.state.scrollPosition + 0; i++) {
                //threshHoldRows.push(this.state.rows[t]);

                let dat = finalData[i];
                if (!dat) {
                    break;
                }

                colCounter = 0;

                dataPieces = [];
                this.props.identity.supportFields.forEach(field => {
                    field = field.substring(0, 1).toLowerCase() + field.substring(1);

                    let supportFieldFriendlyName = "All";

                    if (this.props.identity.isGroupable) {
                        this.props.identity.groupables.forEach(groupable => {
                            supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                        });
                    } else {
                        supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                    }

                    dataPieces.push((
                        <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                            {supportFieldFriendlyName}
                        </div>
                    ));
                })

                this.props.identity.selectedMetrics.forEach(meta => {
                    let isNegative = false;
                    if(this.props.metricDefs != undefined && meta != undefined) {
                        if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)] !== undefined) {
                            isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)].isNegative.toLowerCase());
                        }
                    }
                    if(meta.isYOY) {
                        if(dat.kpi[meta.metric] !== undefined) {
                            let pctYoY = Math.abs((dat.kpi[meta.metric].lyValue - dat.kpi[meta.metric].cyValue) / dat.kpi[meta.metric].lyValue);
                            //let increaseDecrease = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue ? "+" : "-";
    
                            let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;
    
                            dataPieces.push((
                                <div
                                    className={"body-cell kpi"}
                                    style={{
                                        width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                        color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                    }}>
                                    {pctYoY !== Infinity
                                    ? (100 * pctYoY).toFixed(2) + "% "
                                    : ""}
                                </div>
                            ))
                        }
                    } else {
                        if(this.props.metaData[meta.metric] !== undefined && dat.kpi[meta.metric] !== undefined) {
                            let formatId = this.getType(dat.kpi[meta.metric].kpiIdentifier, this.props.identity.dataSet);
                            let type = formatId !== undefined ? formatId : this.props.metaData[meta.metric].type;
                            let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
                            let suffix = type === 'PCT' ? '%' : '';
                            let text = dat.kpi[meta.metric].cyValue;
                            text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));

                            let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                            dataPieces.push((
                                <div
                                    className={"body-cell kpi"}
                                    style={{
                                        width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                        color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                    }}>
                                    {prefix + text + suffix + " "}
                                    <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad") + (this.props.isAABIDash ? " dispNone" : "")}>{"call_made"}</span>
                                </div>
                            ))
                        }
                    }
                })

                threshHoldRows.push((
                    <div key={i} className={"table-row"}>{dataPieces}</div>
                ));


            }
        }

        ///////////////////////////////////////////--THE MAIN ROWS
        dataPieces = [];
        colCounter = 0;
        for (var i = 0 + this.state.scrollPosition; i < this.state.scrollPosition + this.renderedRowCnt; i++) {
            let dat = finalData[i];
            if (!dat) {
                break;
            }

            colCounter = 0;

            dataPieces = [];
            this.props.identity.supportFields.forEach(field => {
                field = field.substring(0, 1).toLowerCase() + field.substring(1);

                let supportFieldFriendlyName = "All";

                if (this.props.identity.isGroupable) {
                    this.props.identity.groupables.forEach(groupable => {
                        supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                    });
                } else {
                    supportFieldFriendlyName = toFriendlyName(identity.dataSet, field, dat.info[field]);
                }

                dataPieces.push((
                    <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                        {supportFieldFriendlyName}
                    </div>
                ));
            })

            this.props.identity.selectedMetrics.forEach(meta => {
                let isNegative = false;
                if(this.props.metricDefs != undefined && meta != undefined) {
                    if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)] !== undefined) {
                        isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(meta.metric)].isNegative.toLowerCase());
                    }
                }
                if(meta.isYOY) {
                    if(dat.kpi[meta.metric] !== undefined){
                        let pctYoY = Math.abs((dat.kpi[meta.metric].lyValue - dat.kpi[meta.metric].cyValue) / dat.kpi[meta.metric].lyValue);
                        if(isNaN(pctYoY) || !isFinite(pctYoY) || pctYoY === null) {
                            pctYoY = 0;
                        }
                        // let increaseDecrease = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue ? "+" : "-";
     
                         let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;
     
                         dataPieces.push((
                             <div
                                 className={"body-cell kpi"}
                                 style={{
                                     width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                     color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                 }}>
                                 {pctYoY !== Infinity
                                 ? (100 * pctYoY).toFixed(2) + "% "
                                 : ""}
                             </div>
                         ))
                    }
                } else {
                    if(this.props.metaData[meta.metric] !== undefined && dat.kpi[meta.metric] !== undefined) {
                        let formatId = this.getType(dat.kpi[meta.metric].kpiIdentifier, this.props.identity.dataSet);
                        let type = formatId !== undefined ? formatId : this.props.metaData[meta.metric].type;
                        let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
                        let suffix = type === 'PCT' ? '%' : '';
                        let text = dat.kpi[meta.metric].cyValue;
                        text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));

                        let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                        dataPieces.push((
                            <div
                                className={"body-cell kpi"}
                                style={{
                                    width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                                    color: `${isNegative ? dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#BD3845"  : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#007A3F" : "" : dat.kpi[meta.metric].cyValue > dat.kpi[meta.metric].lyValue ? "#007A3F" : dat.kpi[meta.metric].cyValue < dat.kpi[meta.metric].lyValue ? "#BD3845" : ""}`
                                }}>
                                {prefix + text + suffix + " "}
                                <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad") + (this.props.isAABIDash ? " dispNone" : "")}>{"call_made"}</span>
                            </div>
                        ))
                    }
                    //else {
                    //    let text = dat.kpi[meta.metric].cyValue;
                    //    let isCyBetter = dat.kpi[meta.metric].cyValue >= dat.kpi[meta.metric].lyValue;

                    //    dataPieces.push((
                    //        <div
                    //            className={"body-cell kpi"}
                    //            style={{
                    //                width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                    //                color: `${isCyBetter ? '#007A3F' : '#BD3845'}`
                    //            }}>
                    //            {" " + text + " "}
                    //            <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad")}>{"call_made"}</span>
                    //        </div>
                    //    ))
                    //}  
                }
            })

            dataRows.push((
                <div key={i} className={"table-row"}>{dataPieces}</div>
            ));
        }

        /////////////////////////////////--END OF THE MAIN ROWS

        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        let totalRowHeight = (finalData.length * 2 * rem) + 'px'; //replace the indexStart with the final data
        let dynamicTopFillerHeight = ((this.state.scrollPosition * rem * 2) - (threshHoldRows.length * rem * 2)) + 'px';
        let dynamicBottomFillerHeight = ((finalData.length - this.state.scrollPosition - this.renderedRowCnt) * rem * 2) + 'px';

        if (this.state.scrollPosition >= (finalData.length - this.renderedRowCnt - 10)) {
            dynamicBottomFillerHeight = '0px';
        }

        let totalRowHeightWrapperStyle = { position: 'absolute', top: '0rem', left: '0rem', width: '100%', height: totalRowHeight };
        let dynamiceTopFiller = { position: 'relative', top: '0rem', left: '0rem', width: '100%', height: dynamicTopFillerHeight };
        let dynamicBottomFiller = { position: 'relative', top: '0rem', left: '0rem', width: '100%', height: dynamicBottomFillerHeight };

        return (<div style={totalRowHeightWrapperStyle}>
            <div style={dynamiceTopFiller}></div>
            {threshHoldRows}
            {dataRows}
            <div style={dynamicBottomFiller}></div>
        </div>)

    }

    generateGrandTotalRow(finalData) {
        
        let identity = this.props.identity;
        
        if (identity.isGrandTotals === undefined || identity.isGrandTotals === null) {
            return null;
        }
        if (identity.isGrandTotals === false) {
            return null;
        }

        let columnCount = this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length;
        let colCounter = 0;
        let dataPieces = [];
        let runningTotalObj = {};

        this.state.columnWidths.forEach(col => {
            if (col === undefined || col === NaN) {
                col = 0;
            }
        });
        
        for (var i = 0; i < finalData.length; i++) {
            let dat = finalData[i];
            if (!dat) {
                break;
            }

            colCounter = 0;
            dataPieces = [];


            this.props.identity.selectedMetrics.forEach(meta => {

                if(meta.isYOY) {
                    if(dat.kpi[meta.metric] !== undefined) {
                        if (!(meta.metric+"YOY" in runningTotalObj)) {
                            runningTotalObj[meta.metric+"YOY"] = {};
                            runningTotalObj[meta.metric+"YOY"].metric = meta.metric;
                            runningTotalObj[meta.metric+"YOY"].isYOY = true;
                            runningTotalObj[meta.metric+"YOY"].cy = dat.kpi[meta.metric].cyValue;
                            runningTotalObj[meta.metric+"YOY"].ly = dat.kpi[meta.metric].lyValue;
                        }
                        else {
                            runningTotalObj[meta.metric+"YOY"].cy += dat.kpi[meta.metric].cyValue;
                            runningTotalObj[meta.metric+"YOY"].ly += dat.kpi[meta.metric].lyValue;
                        }
                    }
                } else  {
                    if(dat.kpi[meta.metric] !== undefined) {
                        if (!(meta.metric in runningTotalObj)) {
                            runningTotalObj[meta.metric] = {};
                            runningTotalObj[meta.metric].cy = dat.kpi[meta.metric].cyValue;
                            runningTotalObj[meta.metric].ly = dat.kpi[meta.metric].lyValue;
                            runningTotalObj[meta.metric].isYOY = false;
                        }
                        else {
                            runningTotalObj[meta.metric].cy += dat.kpi[meta.metric].cyValue;
                            runningTotalObj[meta.metric].ly += dat.kpi[meta.metric].lyValue;
                        }
                    } 
                }
            })
        }
        
        Object.keys(runningTotalObj).forEach(metricObj => {

            if(runningTotalObj[metricObj].isYOY === true) {
                if (this.props.metaData[runningTotalObj[metricObj].metric].isAvg.toLowerCase() === "true" || this.props.metaData[runningTotalObj[metricObj].metric].type === 'PCT') {
                    runningTotalObj[metricObj].cy = (runningTotalObj[metricObj].cy / finalData.length);
                    runningTotalObj[metricObj].ly = (runningTotalObj[metricObj].ly / finalData.length);
                }
            } else {
                if (this.props.metaData[metricObj].isAvg.toLowerCase() === "true" || this.props.metaData[metricObj].type === 'PCT') {
                    runningTotalObj[metricObj].cy = (runningTotalObj[metricObj].cy / finalData.length);
                    runningTotalObj[metricObj].ly = (runningTotalObj[metricObj].ly / finalData.length);
                }
            }

        });
        
        dataPieces.push((
            <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                {'Grand Total'}
            </div>
        ));

        if(this.props.identity.supportFields.length > 1) {
            for (var i = 1; i < this.props.identity.supportFields.length; i++) {
                dataPieces.push((
                    <div className={"body-cell info"} style={{ width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)` }}>
                    </div>
                ));
            }
        }

        Object.keys(runningTotalObj).forEach(metricObj => {
            let isNegative = false;
            if(this.props.metricDefs != undefined && metricObj != undefined) {
                if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(metricObj)] !== undefined) {
                    isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(metricObj)].isNegative.toLowerCase());
                }
            }
            if(runningTotalObj[metricObj].isYOY === true) {

                let pctYoY = Math.abs((runningTotalObj[metricObj].ly - runningTotalObj[metricObj].cy) / runningTotalObj[metricObj].ly);
                //let increaseDecrease = runningTotalObj[metricObj].cy >= runningTotalObj[metricObj].ly ? "+" : "-";

                let isCyBetter = runningTotalObj[metricObj].cy >= runningTotalObj[metricObj].ly;

                dataPieces.push((
                    <div
                        className={"body-cell kpi"}
                        style={{
                            width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                            color:`${isNegative ? runningTotalObj[metricObj].cy > runningTotalObj[metricObj].ly ? "#BD3845"  : runningTotalObj[metricObj].cy < runningTotalObj[metricObj].ly ? "#007A3F" : "" : runningTotalObj[metricObj].cy > runningTotalObj[metricObj].ly ? "#007A3F" : runningTotalObj[metricObj].cy < runningTotalObj[metricObj].ly ? "#BD3845" : "" }`
                        }}>
                        {pctYoY !== Infinity
                        ? (100 * pctYoY).toFixed(2) + "% "
                        : ""}
                    </div>
                ))

            } else {
                let formatId = this.getType(metricObj, this.props.identity.dataSet)
                let type = formatId !== undefined ? formatId : this.props.metaData[metricObj].type;
                let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
                let suffix = type === 'PCT' ? '%' : '';
                let text = runningTotalObj[metricObj].cy;
                text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));

                let isCyBetter = runningTotalObj[metricObj].cy >= runningTotalObj[metricObj].ly;

                dataPieces.push((
                    <div
                        className={"body-cell kpi"}
                        style={{
                            width: `calc(100% / ${columnCount} + ${this.state.columnWidths[colCounter++]}px)`,
                            color: `${isNegative ? runningTotalObj[metricObj].cy > runningTotalObj[metricObj].ly ? "#BD3845"  : runningTotalObj[metricObj].cy < runningTotalObj[metricObj].ly ? "#007A3F" : "" : runningTotalObj[metricObj].cy > runningTotalObj[metricObj].ly ? "#007A3F" : runningTotalObj[metricObj].cy < runningTotalObj[metricObj].ly ? "#BD3845" : "" }`
                        }}>
                        {prefix + text + suffix + " "}
                        <span className={"material-icons compare-arrow" + (isCyBetter ? "" : " bad") + (this.props.isAABIDash ? " dispNone" : "")}>{"call_made"}</span>
                    </div>
                ))
            }
        });

        window.runningTotalObj = runningTotalObj;

        return <div className={"table-row"}>{dataPieces}</div>
    }

    generateTableFooter(finalData) {
        
        let isMenuOpen = this.state.resultsPerPageMenuOpen;

        //let optionsJsx = [5, 10, 15, 250].reduce((r, e) => {
        let optionsJsx = ['All', 5, 10, 25, 50, 100].reduce((r, e) => {
            r.push((
                <div
                    className={"option-simple" + (this.state.resultsPerPage === e ? " active" : "")}
                    onClick={this.setResultsPerPage.bind(null, e)}
                >
                    <div className={"radio"}>
                        <div className={"radio-inner"}></div>
                    </div>
                    <div className={"option-label"}>{e}</div>
                </div>
            ))
            return r;
        }, [])

        let pageNumber = this.state.pageNumber;
        let resultsPerPage = this.state.resultsPerPage;

        let fromIndex = pageNumber * resultsPerPage + 1;
        let toIndex = fromIndex + resultsPerPage - 1;
        let totalIndex = finalData.length;

        if (resultsPerPage === 'All') {
            fromIndex = 1;
            toIndex = totalIndex;
        }

        if (toIndex > totalIndex) {
            toIndex = totalIndex;
        }

        return (
            <div className={"table-footer"}>
                {resultsPerPage === 'All' ? null : <div className={"material-icons footer-button back-forth"} onClick={this.changePage.bind(null, 1)} style={{ top: '0.19rem' }}>{"arrow_forward_ios"}</div>}
                {resultsPerPage === 'All' ? null : <div className={"material-icons footer-button back-forth reverse"} onClick={this.changePage.bind(null, -1)}>{"arrow_forward_ios"}</div>}
                <div className={"footer-text footer-text-right-padding"}>{`${fromIndex}-${toIndex} of ${totalIndex}`}</div>
                <div className="material-icons drop-icon footer-arrow footer-text-right-padding footer-text-cursor" onClick={this.toggleRowSettingOptions.bind(null, true)}>arrow_drop_down</div>
                <div className={"footer-text footer-text-cursor"} onClick={this.toggleRowSettingOptions.bind(null, true)}>{resultsPerPage === 'All' ? 'All Rows ' : `Rows per page: ${this.state.resultsPerPage} `}</div>
                <div className={"options-container footer-text-cursor" + (isMenuOpen ? "" : " hidden")}>
                    {optionsJsx}
                </div>
                <div onClick={this.toggleRowSettingOptions.bind(null, false)} className={"table-footer-blocker" + (isMenuOpen ? "" : " disabled")}></div>
            </div>
        )
    }

    handleScrollEvent(e) {
        this.handleScroll(e.target.scrollTop);
    }

    async handleScroll(eventScrollTop) {

        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        this.setState({
            scrollPosition: Math.floor(eventScrollTop / (2 * rem))
        });
    }

    render() {

        let identity = this.props.identity;
        let finalData = this.searchData();
        window.finalData = finalData;
        let tableBodyStyle = {};
        let renderGrandTotals = false;

        if (identity.isGrandTotals !== undefined && identity.isGrandTotals !== null && identity.isGrandTotals === true) {
            renderGrandTotals = true;
        }

        if (renderGrandTotals === true) {
            tableBodyStyle = {
                height: 'calc(100% - 4rem)'
            }
        } else {
            tableBodyStyle = {
                height: 'calc(100% - 2rem)'
            }
        }

        let columnCount = this.props.identity.supportFields.length + this.props.identity.selectedMetrics.length;
        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        let xScrollMinWidthStyle = { minWidth: (columnCount * rem * 10) + 'px' };

        return (
            <div id={`workspace-table-chart-${this.props.identity.id}`} className={"workspace-table-chart-outer"}>
                {this.generateOptionsBar()}
                <div className={"workspace-table-chart-inner"}>
                    <div className={"workspace-chart-inner-x-scroll"} style={xScrollMinWidthStyle}>
                        <div className={"table-header"}>{this.generateHeaders()}</div>
                        <div className={"table-body"} style={tableBodyStyle} onScroll={this.handleScrollEvent}>{this.state.resultsPerPage === 'All' ? this.generateDataRowsInfiniteScrollWay(finalData) : this.generateDataRows(finalData)}</div>
                        {renderGrandTotals === true ? <div className={"table-body-grand-total"}>{this.generateGrandTotalRow(finalData)}</div> : null}
                    </div>
                </div>
                {this.generateTableFooter(finalData)}
            </div>
        );
    }
}